// src/pages/HistoryPageChina.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Ancient_Civilizations_-_Mesopotamia.png';

export default function HistoryPageMesopotamia() {
  return (
    <TopicPage
      topicKey="Mesopotamia"
      title="History: Ancient Mesopotamia"
      backgroundImage={bg}
      startRoute="/History-Ancient-Mesopotamia-Go"
      scrollLabels={[
        "Code of Hammurabi",
        "City-States and Economy",
        "Ziggurats and Religion",
      ]}
  backRoute="/history-Ancient-Civilizations"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
